import React, {useState, useEffect} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import {getUrlValue} from '../../util';
import RadioFormItem from '../../components/RadioFormItem/index';
import FeedbackModal from '../appeal/feedbackModal';
import {Button, Modal} from 'antd';
import successIcon from '../../asset/img/appeal/submit_succeed.png';
import {IP_APPEAL_QUESTION_OPTIONS, SOURCE_OPTIONS} from '../appeal/conf';
import {login, handleLogin, bCat_2055_request} from '../../util';
import warnIcon from '../../../src/components/LocationResult/imgs/no-data.svg';

import {fetchIpInfo, submitIpAppeal, fetchIpUserInfo} from '../../actions/ipAppealAction';
import {initCaptcha} from '../../../src/constants/utils';

import './index.less';

export const ipQuestionStateErr = {
    ipQuestionTypeErr: '',
};

interface IProps {
    fetchIpUserInfo: () => void;
    fetchIpInfo: typeof fetchIpInfo;
    submitIpAppeal: typeof submitIpAppeal;
}

function validateIP(ip) {
    /* eslint-disable */
    const ipv4Regex = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])(\/\d{1,2}|1\d\d|2[0-4]\d|25[0-5])?$/;
    const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/i;
    /* eslint-enable */
    return ipv4Regex.test(ip) || ipv6Regex.test(ip);
}
export const IpAppealPage: React.FC<IProps> = (props) => {
    const {fetchIpUserInfo, submitIpAppeal} = props;
    const [appealData, setAppealData] = useState({
        questionImg: [] as any,
        questionType: 0, // 写死，用于区分问题说明的placeholder
        questionContent: '',
        questionContentErr: '',
        ipQuestionType: '',
        ipQuestionTypeErr: '',
    });
    const [curStep, setCurStep] = useState(1);
    const [isIpValid, setIsIpValid] = useState(true);
    const ipValue = decodeURIComponent(getUrlValue('ip') || '');
    const src = decodeURIComponent(getUrlValue('src') || '');
    const region = decodeURIComponent(getUrlValue('region') || '');
    const isp = decodeURIComponent(getUrlValue('isp') || '');
    const scene = decodeURIComponent(getUrlValue('scene') || '');
    const securityRisks = decodeURIComponent(getUrlValue('securityRisks') || '');

    useEffect(() => {
        window.scrollTo(0, 0);
        handleLogin(fetchIpUserInfo);
    }, [location.pathname]);

    useEffect(() => {
        if (ipValue) {
            const isValid = validateIP(ipValue);
            setIsIpValid(isValid);
        }
    }, [ipValue]);

    const updateAppeal = (value, type?) => {
        if (type) {
            setAppealData({
                ...appealData,
                [type]: value,
                [`${type}Err`]: ''
            });
        } else {
            setAppealData({
                ...appealData,
                ...value
            });
        }
    };

    const handleValues = (defaultText, values) => {
        if (!values) {
            return defaultText;
        }
        return values.split(',').filter((item) => item.trim()).join('，');
    };

    const handleSource = () => {
        let srcValue = 0; // 0: 未知
        if (src) {
            srcValue = SOURCE_OPTIONS[src as keyof typeof SOURCE_OPTIONS] || 0;
        }
        return srcValue;
    };

    const onSubmit = () => {
        const {ipQuestionType, questionContent, questionImg} = appealData;
        let tempObj = {...appealData};

        if(!ipQuestionType) {
            tempObj.ipQuestionTypeErr = '请选择问题类型';
        }
        if (!questionContent) {
            tempObj.questionContentErr = '请输入问题说明';
        }
        if (!ipQuestionType || !questionContent) {
            setAppealData({
                ...appealData,
                ...tempObj
            });
            return;
        }
        let imgLink = '';
        if (questionImg.length > 0) {
            const tempImgRes = questionImg[0].response;
            imgLink = tempImgRes?.data?.link || '';
        }
        initCaptcha((tk) => {
            const submitFn = (params) => submitIpAppeal({
                ...params,
                desc: questionContent,
                class: ipQuestionType,
                link: imgLink,
                svcp_stk: tk || '',
                ip: ipValue,
                source: handleSource()
            }).then(res => {
                if (res?.code === 200) {
                    setCurStep(2);
                } else if (res?.code === 401) {
                    login();
                } else {
                    Modal.warning({
                        title: '结果提示',
                        content: '提交失败，请稍后重试',
                        okText: '知道了',
                        centered: true
                    });
                }
            });
            bCat_2055_request(submitFn);
        });
    };
    return (<div className="ip-appeal-page">
        <div className="top-banner">
            <div className={'carousel-item ip-appeal-banner'}>
                <div className="item-info-wrapper">
                    <span className="title">百度智能云·IP风险画像·信息报错</span>
                </div>
            </div>
        </div>
        {(!ipValue || !isIpValid) && (<div>
            <div className="ip-appeal-success">
                <img width={90} src={warnIcon} />
                <p className="title"></p>
                <p className="sub-title">
                    IP地址格式无效
                </p>
            </div>
        </div>)}
        {(ipValue && isIpValid) && (<>
            {curStep === 1 && (<>
                <div className="ip-msg">
                    <div className="ip-num">IP：{ipValue}</div>
                    <div className="ip-detail-wrap">
                        <div className="ip-detail-item">
                            <div className="ip-detail-item-title">归属地：</div>
                            <div className="ip-detail-item-value">
                                {handleValues('未知', region)}
                            </div>
                        </div>
                        <div className="ip-detail">
                            <div className="ip-detail-item">
                                <div className="ip-detail-item-title">运营商：</div>
                                <div className="ip-detail-item-value">
                                    {isp || '--'}
                                </div>
                            </div>
                            <div className="ip-detail-item">
                                <div className="ip-detail-item-title">应用场景：</div>
                                <div className="ip-detail-item-value">
                                    {scene || '--'}
                                </div>
                            </div>
                        </div>
                        <div className="ip-detail-item">
                            <div className="ip-detail-item-title">风险标签：</div>
                            <div className="ip-detail-item-value">
                                {handleValues('暂无风险', securityRisks)}

                            </div>
                        </div>
                    </div>
                </div>
                <div className="ip-form">
                    <div style={{height: '57px'}}>
                        <RadioFormItem
                            title="问题类型"
                            isMsgRequired={true}
                            type="ipQuestionType"
                            options={IP_APPEAL_QUESTION_OPTIONS}
                            data={appealData}
                            customClassName="question-type-radio"
                            onChange={(e) => updateAppeal(e.target.value, 'ipQuestionType')}
                        />
                    </div>
                    <FeedbackModal
                        appealData={appealData}
                        isFeedbackRequired={true}
                        updateAppeal={updateAppeal}
                        maxLength={200}
                        textWidth="750px"
                    />
                    <Button
                        className="ip-submit-btn"
                        type="primary"
                        onClick={onSubmit}
                    >
                        提交
                    </Button>
                </div>
            </>)}
            {curStep === 2 && <div className="ip-appeal-success">
                <img width={152} src={successIcon} />
                <p className="title">提交成功!</p>
                <p className="sub-title">
                    {'我们会尽快完成审核，请耐心等待'}
                </p>
            </div>}
        </>)}
    </div>);
};

function mapStateToProps(state) {
    return {
        userInfo: state.userInfo
    };
}
function mapDispatchToProps(dispatch) {
    return {
        fetchIpUserInfo: () => fetchIpUserInfo(dispatch),
        fetchIpInfo: value => fetchIpInfo(dispatch, value),
        submitIpAppeal: obj => submitIpAppeal(dispatch, obj)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IpAppealPage as any));
